import React from 'react'
import { NavLink } from 'react-router-dom'
import { BsGrid, BsPerson, BsJournalBookmark, BsNewspaper, BsBook } from "react-icons/bs";

function Sidebar() {
  return (
    <div className='Sidebar'>
        <div className="logo">
            ФизМат
        </div>

        <ul>
            <li><BsGrid /> <NavLink to="/admin/groups">Группы</NavLink></li>
            <li><BsPerson /> <NavLink to="/admin/users">Ученики</NavLink></li>
            <li><BsJournalBookmark /> <NavLink to="/admin/rasp">Расписание</NavLink></li>
            <li><BsBook /> <NavLink to="/admin/subjects">Предметы</NavLink></li>
            <li><BsNewspaper /> <NavLink to="/admin/news">Новости</NavLink></li>
        </ul>

        <div className="leave">
            <a href="#">Выйти</a>
        </div>
    </div>
  )
}

export default Sidebar